export * from "ce/pages/AdminSettings/Main";
import { default as CE_Main } from "ce/pages/AdminSettings/Main";
export default CE_Main;
